export function formatCurrency(amount, locale = "fi-FI") {
    const formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: "EUR",
    });
    return formatter.format(amount);
}
